import React, {useState, useEffect} from 'react'
import { useHistory } from "react-router-dom";
import {connect} from 'react-redux';
import Slider from "react-slick";
import {Transition} from 'semantic-ui-react'
import {setMenuVisible, pageChange} from '../actions/'

import {productionBaseUrl} from '../config/const';
import styles from './LatestDetail.module.scss'
import './LatestDetail.css'

const LatestDetail = (props) => {
    const history = useHistory();
    const gotoProductionList = () => {
        // history.push("/production_list");
    }

    const [isPageVisible, setPageVisible] = useState(false);
    const [steps, setSteps] = useState([false]);
    const [sliderWidth, setSliderWidth] = useState(0);
    const [sliderHeight, setSliderHeight] = useState(0);

    useEffect(() => {
        setPageVisible(true);
        // setSliderWidth(Math.floor(document.getElementById("content_container").offsetWidth * (866/1280)));
        // setSliderHeight(Math.floor(document.getElementById("content_container").offsetHeight * (533/800)));
    });

    function setStepVisible(index, visible) {
        const stepsCopy = [...steps];
        stepsCopy[index] = visible;
        setSteps(stepsCopy);
    }

    function getSubtitle(selfDefineCategory, categoryKey){
        if (selfDefineCategory !== null && "" !== selfDefineCategory) {
            return selfDefineCategory;
        }
        else {
            switch(categoryKey) {
                case 1:
                    return "FILM";
                    break;
                case 2:
                    return "TELEFILEM";
                    break;
                case 3:
                    return "SHORT FILM";
                    break;
                case 4:
                    return "Documentary";
                    break;
            }
        }
    }

    const sliderSetting = {
        arrows: false,
        dots: true,
        autoplay: true
    }

    const sliderMobileSetting = {
        arrows: false,
        dots: false,
        autoplay: true,
        swipe: false
    }

    const handleMenuItemClick = (path, e) => {
        e.preventDefault();
        e.stopPropagation();
        props.pageChange({
            prevUrl: history.location.pathname,
            nextUrl: path
        });
    }

    const getLanguageClass = () => {
        switch(props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    return (
        <>
            <div className={`latest ${styles.latest} ${styles.desktop} ${getLanguageClass()}`}>
                <Transition visible={isPageVisible} animation='fade' duration={1000} onShow={() => {
                    setStepVisible(0, true)
                }}>
                    <div>
                        {props.showScrollDown ?
                        <div className={styles.scroll_down}>
                            <div className={styles.text}>SCROLL</div>
                            <div className={styles.arrow_block}>
                                <div className={`arrow down ${styles.arrow} ${styles.top}`}></div>
                                <div className={`arrow down ${styles.arrow} ${styles.down}`}></div>
                            </div>
                        </div>
                          : null }

                        <Transition visible={steps[0]} animation='fade' duration={1000}>
                            <div className={styles.page}>
                                <div className={styles.page_title}>{props.production.name}</div>
                                <div
                                    className={styles.page_subtitle}>{props.production.year} · {getSubtitle(props.production.selfDefineCategory, props.production.category.key)}</div>
                            </div>
                        </Transition>
                        <Transition visible={steps[0]} animation='fade' duration={1000}>
                            <div className={`${styles.direct_link_container} flex`} onClick={gotoProductionList}>
                                <div className={styles.direct_link} onClick={e => handleMenuItemClick("/production/"+props.production.id, e)}>See More</div>
                                <div className={styles.line}>
                                    <hr/>
                                </div>
                            </div>
                        </Transition>

                        <div className={styles.content}>
                            <Slider {...sliderSetting}>
                                {
                                    props.production.images.filter(image=>image.apply).filter(item=>item.type==="desktop").map((item, index) => {
                                        return <div key={index} className={styles.content_slide}>
                                            <div className={styles.img} style={
                                                {
                                                    backgroundImage: `url("${productionBaseUrl + item.path}"`,
                                                    // width: sliderWidth,
                                                    // height: sliderHeight
                                                }
                                            }></div>
                                        </div>
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                </Transition>
            </div>

            <div className={`latest ${styles.latest} ${styles.mobile} ${getLanguageClass()}`}>
                <div className={styles.content}>
                    <div className={styles.slider_wrapper}>
                      <Slider {...sliderMobileSetting}>
                          {
                              props.production.images.filter(image=>image.apply).filter(item => item.type === "mobile").map((item, index) => {
                                  return <div key={index} className={styles.content_slide}>
                                      <div className={styles.img} style={
                                          {
                                              backgroundImage: `url("${productionBaseUrl + item.path}"`
                                          }
                                      }></div>
                                  </div>
                              })
                          }
                      </Slider>
                    </div>
                    <div className={styles.page}>
                        <div className={styles.page_subtitle}>{props.production.year} · {getSubtitle(props.production.selfDefineCategory, props.production.category.key)}</div>
                        <div className={styles.page_title}>{props.production.name}</div>
                    </div>
                    <div className={styles.direct_link_container} onClick={gotoProductionList}>
                        <div className={styles.direct_link_line}></div>
                        <div className={styles.direct_link} onClick={e => handleMenuItemClick("/production/"+props.production.id, e)}>See More</div>
                    </div>
                </div>
            </div>
        </>);
};

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps, {setMenuVisible, pageChange})(LatestDetail);
